export class Field {
  visibility: string;
  fieldType: string;
  name: string;
  defaultValue: string;

  constructor(visibility: string, fieldType: string, name: string, defaultValue: string = '') {
    this.visibility = visibility;
    this.fieldType = fieldType;
    this.name = name.replace(';', '');
    this.defaultValue = defaultValue;
  }

  toUmlString(): string {
    let umlString = `${this._getVisibilitySymbol()} ${this.name}: ${this.fieldType}`;
    if (this.defaultValue !== '') umlString += ` ${this.defaultValue}`;
    return umlString;
  }

  private _getVisibilitySymbol(): string {
    if (this.visibility === 'private') return '-';
    if (this.visibility === 'public') return '+';
    return '#';
  }
}
